import { Injectable } from '@angular/core';
import { HttpHandler, HttpInterceptor, HttpRequest, HttpUrlEncodingCodec } from '@angular/common/http';

declare let NIUA: any;

@Injectable()
export class PricingAuthInterceptor implements HttpInterceptor {
  private authToken?: string;

  constructor() {
    if (typeof NIUA !== 'undefined') {
      const myNIUA = NIUA.getNIUA({});
      myNIUA.ready().then(() => {
        this.authToken = myNIUA.createNIAuthToken();
      });
    }
  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (req.url.includes('pricing')) {
      if (this.authToken) {
        const codec = new HttpUrlEncodingCodec();
        const authReq = req.clone({
          setParams: { authToken: codec.encodeValue(this.authToken) },
        });
        return next.handle(authReq);
      }
    }
    return next.handle(req);
  }
}
